import { noop } from "lodash";
import type { RegisterOptions } from "react-hook-form";
import { useFormContext } from "react-hook-form";
import { ButtonWithDisabled } from "../ButtonWithDisabled/index";
import "./styles.scss";

export interface CounterProps {
  className?: string;
  max?: number;
  min?: number;
  name: string;
  onChange?: (value: number) => void;
  rules?: RegisterOptions;
  step?: number;
}

export const Counter = ({
  name,
  rules = {},
  onChange = noop,
  className = "form-control",
  step = 1,
  min = 0,
  max,
}: CounterProps) => {
  const { register, setValue, getValues } = useFormContext();

  const onDecrement = () => {
    const oldValue = getValues(name);
    const newValue = parseInt(oldValue) - step;
    if (newValue < 0) return;
    setValue(name, newValue);
    onChange(newValue);
  };

  const onIncrement = () => {
    const oldValue = getValues(name);
    const value = parseInt(oldValue) + step;
    const newValue = max && max > 0 ? Math.min(value, step * max) : value;
    setValue(name, newValue);
    onChange(newValue);
  };

  return (
    <div className="react-counter">
      <ButtonWithDisabled variant="secondary-light" onClick={onDecrement}>
        <span>-</span>
      </ButtonWithDisabled>
      <input
        readOnly
        type="number"
        className={className}
        step={step}
        min={min}
        {...register(name, rules)}
      />
      <ButtonWithDisabled variant="secondary-light" onClick={onIncrement}>
        <span>+</span>
      </ButtonWithDisabled>
    </div>
  );
};
